module.exports = __webpack_public_path__ + "img/10min.37ededb3.svg";